<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row ">

    <div class="col-lg-12 col-md-12 col-12">
      <div class="card">
        <div class="card-body">
          <!-- <div class="form-group align-items-center">
            <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="update number of Visitors" (click)="onUpdate()" name="btnUpdate">
              <span><i class="fa fa-spin fa-refresh"></i>&nbsp;<small style="color:rgb(255, 255, 255);">Update</small></span>
            </button>
          </div> -->
          <div echarts [options]="option" class="demo-chart"></div>
          <div class="loader-box">
            <b>{{countDown}}</b>
            <div class="loader">
              <div class="line bg-primary"></div>
              <div class="line bg-primary"></div>
              <div class="line bg-primary"></div>
              <div class="line bg-primary"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
